export default __webpack_public_path__ + "static/media/favorite_star.d0cbd94e.png";